import { LocationComposite } from '@lib.core/entities/location/location-composite.entity';

export interface LocationCompositeDto {
  countryCode: string;
  geoType: string;
  geoCode: string;
}

export function newLocationCompositeEntityFromDtos(dtoList: LocationCompositeDto[], locationId: string): [LocationComposite | null, Error | null] {
  if (dtoList.length === 0) {
    return [null, new Error('custom location dto cannot be an empty list')];
  }
  const entity = new LocationComposite(locationId);
  entity
    .setGeoType(dtoList[0].geoType)
    .setCountryCode(dtoList[0].countryCode)
    .setGeocodes(dtoList.map(dto => dto.geoCode));
  const err = entity.validate();
  if (err !== null) {
    return [null, err];
  }
  return [entity, null];
}
